import React from "react"
import { useSiteMetadata } from "./useSiteMetadata"
import { useLocation } from "@reach/router"
export const Seo = ({ title, ogtitle, description, type, image, children }) => {
  const location = useLocation()
  const pathname = location.pathname
  const siteUrl = location.origin
  const { title: defaultTitle, description: defaultDescription } =
    useSiteMetadata()

  const seo = {
    title: title || defaultTitle,
    ogtitle: ogtitle || title,
    description: description || defaultDescription,
    url: `${siteUrl}${pathname}`,
    type: type || "website",
    image: image || "og-generic",
  }

  return (
    <>
      <title key="title">{seo.title}</title>
      <meta key="description" name="description" content={seo.description} />
      <meta key="ogtitle" property="og:title" content={seo.ogtitle} />
      <meta
        key="ogdescription"
        property="og:description"
        content={seo.description}
      />
      <meta key="ogurl" property="og:url" content={seo.url} />
      <meta key="ogtype" property="og:type" content={seo.type} />
      <meta key="oglocale" property="og:locale" content="en_GB" />
      <meta
        key="imageurl"
        property="og:image"
        content={`https://htslabs.com/social/${seo.image}.jpg`}
      />
      <meta key="imagetype" property="og:image:type" content="image/jpeg" />
      <meta key="imagewidth" property="og:image:width" content="1200" />
      <meta key="imageheight" property="og:image:height" content="630" />
      <meta
        key="imagealt"
        property="og:image:alt"
        content="See more technical resources at htslabs.com"
      />

      <link
        key="stylesheet"
        rel="stylesheet"
        href="https://rsms.me/inter/inter.css"
      />
      {children}
    </>
  )
}

export default Seo
